import { DistanceType } from './Distance';
import { StanceType } from './Stance';

/**
 * バトルエフェクトの種類
 */
export enum BattleEffectType {
  /** ダメージ数値表示 */
  DAMAGE_NUMBER = 'DAMAGE_NUMBER',
  /** 武器攻撃エフェクト */
  WEAPON_ATTACK = 'WEAPON_ATTACK',
  /** 特殊攻撃エフェクト */
  SPECIAL_ATTACK = 'SPECIAL_ATTACK',
  /** 回避エフェクト */
  EVASION = 'EVASION',
  /** 距離移動アニメーション */
  DISTANCE_MOVE = 'DISTANCE_MOVE',
  /** スタンス変更エフェクト */
  STANCE_CHANGE = 'STANCE_CHANGE',
  /** リフレクター構えエフェクト（攻撃が来なかった場合） */
  REFLECTOR_DEPLOY = 'REFLECTOR_DEPLOY',
  /** リフレクター残回数切れブロックエフェクト（特殊を無効化したが反射できなかった場合） */
  REFLECTOR_BLOCK = 'REFLECTOR_BLOCK',
  /** 特殊攻撃がリフレクターで反射された連続アニメーション */
  SPECIAL_REFLECT = 'SPECIAL_REFLECT',
  /** 特殊攻撃が武器攻撃で潰された場合の溜め→崩れ演出 */
  SPECIAL_CHARGE_FIZZLE = 'SPECIAL_CHARGE_FIZZLE',
  /** 特殊攻撃が回避された連続アニメーション（溜め→光球飛翔→着弾瞬間回避） */
  SPECIAL_EVASION = 'SPECIAL_EVASION',
  /** 前進+後退相殺（距離変化なし）の視覚エフェクト */
  ADVANCE_RETREAT = 'ADVANCE_RETREAT',
  /** 武器攻撃が射程外で空振りした演出（攻撃者がスイングするが当たらない） */
  WEAPON_MISS = 'WEAPON_MISS',
}

/** エフェクトのターゲット */
export type EffectTarget = 'player' | 'enemy';

/**
 * 個別のバトルエフェクト
 */
export interface BattleEffect {
  /** エフェクトの種類 */
  type: BattleEffectType;
  /** エフェクトの対象 */
  target: EffectTarget;
  /** ダメージ値等 */
  value?: number;
  /** 距離移動の開始距離 */
  distanceFrom?: DistanceType;
  /** 距離移動の終了距離 */
  distanceTo?: DistanceType;
  /** スタンス変更後のスタンス */
  stanceTo?: StanceType;
  /** SPECIAL_REFLECT: 攻撃者に返る反射ダメージ量 */
  reflectedDamage?: number;
  /** ADVANCE_RETREAT: 前進した側のターゲット */
  advancerTarget?: EffectTarget;
  /** SPECIAL_ATTACK: 回数超過で威力が低下している場合 true */
  isWeakened?: boolean;
}

/**
 * バトルエフェクトのシーケンス
 * 外側配列 = フェーズ（順次実行）
 * 内側配列 = 同時実行するエフェクト群
 */
export type BattleEffectSequence = BattleEffect[][];
